<div class="modals__container">
  <div class="modals__header">
    <img
      mfpLazyImage
      lazySrc="assets/icons/close.svg"
      alt=""
      class="modals__close"
      (click)="close()"
    />
  </div>
  <div class="university">
    <h1 class="university__title">{{ 'UNIVERSITY.TITLE' | translate }}</h1>
    <form
      [formGroup]="universityForm"
      (ngSubmit)="save()"
    >
      <div class="university__container mfp-white-box">
        <div class="inputs">
          <div class="row">
            <div class="col-xs-24 col-sm-16 col-gutter-lr">
              <mfp-select
                formControlName="location"
                name="location"
                [label]="'UNIVERSITY.FORM.LOCATION' | translate"
                [placeholder]="'SELECT' | translate"
                [options]="locations"
                [required]="true"
                [readonly]="lifePlan.status === 'SENT'"
                [success]="isFieldValid(universityForm, 'location')"
                [error]="isFieldInvalid(universityForm, 'location')"
                [helper]="getFieldError(universityForm, 'location') | translate"
                ></mfp-select>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-24 col-sm-16 col-gutter-lr">
              <mfp-select
                formControlName="university"
                name="university"
                [label]="'UNIVERSITY.UNIVERSITY' | translate"
                [placeholder]="'SELECT' | translate"
                [options]="universities"
                [required]="true"
                [readonly]="lifePlan.status === 'SENT'"
                [success]="isFieldValid(universityForm, 'university')"
                [error]="isFieldInvalid(universityForm, 'university')"
                [helper]="getFieldError(universityForm, 'university') | translate"
              ></mfp-select>
            </div>
          </div>
        </div>
        <div class="costs">
          <div class="row row--no-margin between-xs between-sm">
            <h2 class="costs__text">{{ 'UNIVERSITY.COSTS.UNIVERSITY' | translate }}</h2>
            <ng-container *ngIf="universityCost.amount > 0">
              <h1 class="costs__text-bold  costs__text-number">
                <mfp-amount-currency>
                  <span amount>{{ universityCost.amount | configCurrency }}</span>
                  <sup currency> {{ getCurrencyKey(universityCost.currency, currencyOptions) }}</sup>
                </mfp-amount-currency>
              </h1>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="university__actions">
        <mfp-button
          type="button"
          color="primary"
          fill="outline"
          [label]="'CANCEL' | translate"
          [disabled]="false"
          (click)="close()"
        ></mfp-button>

        <mfp-button
          class="university__actions-save"
          type="submit"
          color="primary"
          fill="default"
          [label]="'SAVE' | translate"
          [disabled]="universityForm.invalid || lifePlan.status === 'SENT'"
        ></mfp-button>
      </div>
    </form>
  </div>
</div>
